window.addEventListener('load', () => {
    if (typeof Swiper !== 'function' && typeof Swiper !== 'object') return;

    document.querySelectorAll('[data-swiper-options]').forEach((elem) => {
        const optionsAttr = elem.getAttribute('data-swiper-options');
        const swiperOptions = optionsAttr ? JSON.parse(optionsAttr) : {};
        new Swiper(elem, swiperOptions);

        const loadingAttr = elem.getAttribute('data-swiper-loading');
        if (loadingAttr) {
            const loadingElement = document.getElementById(loadingAttr);
            if (loadingElement) loadingElement.style.display = 'none';
        }
        elem.style.visibility = 'visible';
    });
});
